module.exports = __webpack_public_path__ + "static/scale-model-of-thrill-hill-in-st.-petersburg-florida-c4c0fac60eb3682b6ad87201ccfa81a5.png";